export const azureAksAgentPoolPaths = {
  list: (connectionId, resourceGroup, clusterName) =>
    `/compute/cloud-account-connections/${connectionId}/azure/aks/clusters/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(clusterName)}/agent-pools`,
  create: (connectionId, resourceGroup, clusterName) =>
    `/compute/cloud-account-connections/${connectionId}/azure/aks/clusters/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(clusterName)}/agent-pools`,
  detail: (connectionId, resourceGroup, clusterName, agentPoolName) =>
    `/compute/cloud-account-connections/${connectionId}/azure/aks/clusters/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(clusterName)}/agent-pools/${encodeURIComponent(agentPoolName)}`,
};
